// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Angular Material Files
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import {
    MatLegacyProgressSpinnerModule
} from '@angular/material/legacy-progress-spinner';

// Teller Online Library Files
import {
    TellerOnlineScheduleDetailsModule
} from 'teller-online-libraries/shared';

// Component Files
import {
    ScheduleDetailsModalComponent
} from './schedule-details-modal.component';
import {
    FullPageModalHeaderModule
} from '../full-page-modal-header/full-page-modal-header.module';
import {
    PaymentMethodDisplayModule
} from '../payment-method-display/payment-method-display.module';

@NgModule({
    declarations: [ScheduleDetailsModalComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatLegacyDialogModule,
        MatLegacyCheckboxModule,
        MatLegacyButtonModule,
        MatIconModule,
        MatLegacyProgressSpinnerModule,
        TellerOnlineScheduleDetailsModule,
        FullPageModalHeaderModule,
        PaymentMethodDisplayModule,
    ],
    exports: [ScheduleDetailsModalComponent]
})
export class ScheduleDetailsModalModule {}
